import React from 'react'

import {
  Box,
  Icon,
  Text,
  Display,
  AlignItems,
  JustifyContent,
  Space,
  Color,
  IconVariant,
} from '@gousto-internal/citrus-react'

import { signupConfig } from 'routes/Signup/signupConfig'

export const PostcodeStepMessage = ({ deliveryDaysError }: { deliveryDaysError: string }) => {
  let text
  if (deliveryDaysError === 'do-not-deliver') {
    text = signupConfig.postCodeStep.doNotDeliverErrorMessage
  } else if (deliveryDaysError) {
    text = signupConfig.postCodeStep.genericErrorMessage
  } else {
    text = signupConfig.postCodeStep.reminder
  }

  return (
    <Box
      display={Display.Flex}
      alignItems={AlignItems.Center}
      justifyContent={JustifyContent.Center}
      color={deliveryDaysError ? Color.Error_900 : Color.Success_600}
      data-testid="PostcodeStepMessage"
    >
      {!deliveryDaysError && (
        <>
          <Icon name="tick" variant={IconVariant.Inherit} />
          <Space direction="horizontal" size={1} />
        </>
      )}
      <Text size={2}>{text}</Text>
    </Box>
  )
}
